import React from 'react'

import { NoticeBox, UiCloseSmallIcon, VsWrenchIcon, theme } from '@octane/spark'
import styled from 'styled-components'

const StickyDiv = styled.div`
    position: fixed;
    left: 0;
    top: 60px;
    border: 1px solid #d5d9e0;
    border-radius: 5px;
    z-index: 1;

    #refreshButton {
        margin-left: 5px;
        margin-right: 140px;
        color: ${({ theme: scTheme }) => scTheme.colors.brand.primary};
        text-decoration: underline;
        cursor: pointer;
    }

    #closeButton {
        position: absolute;
        right: 16px;
        top: 16px;
        cursor: pointer;
    }

    *:nth-child(1) {
        background-color: ${({ theme: scTheme }) =>
            scTheme.colors.brand.background};
    }
`

interface UpdateAvailableNoticeProps {
    readonly renderNotification: (value: boolean) => void
}

export default function UpdateAvailableNotice(
    props: UpdateAvailableNoticeProps,
) {
    const { renderNotification } = props
    const reloadPage = () => window.location.reload()

    return (
        <StickyDiv>
            <NoticeBox
                icon={VsWrenchIcon}
                color="success"
                variant="box-highlighted"
                title="A new version is available."
            >
                <span>Please reload the page to get the latest version.</span>
                <button id="refreshButton" type="button" onClick={reloadPage}>
                    Refresh now
                </button>
            </NoticeBox>
            <UiCloseSmallIcon
                id="closeButton"
                data-testid="updateNotificationCloseButton"
                color={theme.colors.monochrome.ravenSub}
                height={24}
                width={24}
                onClick={() => renderNotification(false)}
            />
        </StickyDiv>
    )
}
